import SplitHero from './SplitHero'

export default SplitHero
